import { Component } from '@angular/core';

@Component({
  selector: 'app-read-me',
  standalone: false,
  templateUrl: './read-me.component.html',
  styleUrl: './read-me.component.css'
})
export class ReadMeComponent {

}